import component from '../../../../props/component'
import form from '../../../../props/form'
import processing from '../../../../props/processing'

const localProps = {
  token: {},
  item: {},
  showFormLabels: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showFormLabels', true)
    }
  },
  showFormPlaceholders: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showFormPlaceholders', false)
    }
  },
  showFormFieldHint: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showFormFieldHint', true)
    }
  },

  classes: {
    type: [String, Array, Object],
     default() {
      return this.$options.$$s('classes', null)
    }
  },

  noAgreeToTerms: {
    type: [Boolean, Number],
    default() {
      return !this.$options.$$s('showTerms', true)
    }
  },
  amountBoxTitle: {
    type: String,
    default() {
      return this.$options.$$t('form.product.title', 'Select your amount')
    }
  },
  amountBoxSubtitle: {
    type: String,
    default() {
      return this.$options.$$t('form.product.subtitle', 'Please choose the gift card amount.')
    }
  },
  amountBoxLabel: {
    type: String,
    default() {
      return this.$options.$$t('form.product.label', 'Amount')
    }
  },
  personalDetailsTitle: {
    type: String,
    default() {
      return this.$options.$$t('form.customer.title', 'Personal information')
    }
  },
  personalDetailsSubtitle: {
    type: String,
    default() {
      return this.$options.$$t('form.customer.subTitle', 'Please enter your contact details.')
    }
  },
  noPhoneInput: {
    type: [Boolean, Number],
    default() {
       return !!this.$options.$$s('noPhoneInput', true)
    }
  },
  recipientBoxTitle: {
    type: String,
    default() {
      return this.$options.$$t('form.recipient.title', 'This Gift Card is for (recipient)')
    }
  },
  recipientBoxSubtitle: {
    type: String,
    default() {
      return this.$options.$$t('form.recipient.subTitle', 'Please enter contact details.')
    }
  },
  previewCardBoxTitle: {
    type: String,
    default() {
      return this.$options.$$t('form.preview.title', 'Preview: The gift card email will look like this')
    }
  },
  previewCardBoxHtml: {
    default() {
      return this.$options.$$t('form.preview.template', null)
    }
  },
  isGiftNoteRequired: {
    type: [Boolean, Number],
    default() {
       return !!this.$options.$$s('form.fields.giftNote.validations', false)
    }
  },
  loadingMessage: {
    type: String,
    default() {
      return this.$options.$$t('loadingMessage', 'Your order is being processed...')
    }
  },
  cartItemEditable: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('cartItemEditable', true)
    }
  },
}
export const props = {
  ...component,
  ...form,
  ...processing,
  ...localProps
}
export default props
